import { TableRow as Row } from "@mui/material"
import { colors } from "../../services/config/colors"
import { CSSProperties, ReactNode } from "react"

const TableRow = ({
  index,
  children,
  onClick,
  style,
}: {
  index: number
  children?: ReactNode
  onClick?: () => void
  style?: CSSProperties
}) => {
  return (
    <Row
      key={index}
      style={{
        transition: "50ms",
        backgroundColor: index % 2 === 0 ? "#F2F3F4" : colors.backgroundWhite,
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
      sx={{
        "td, th": { border: 0 },
        "&:hover": onClick
          ? {
              opacity: 0.8,
            }
          : {},
      }}
      onClick={onClick}
    >
      {children}
    </Row>
  )
}

export default TableRow
